export default function getPreregisterDate() {
  return process.env.VUE_APP_PREREGISTER_DATE
    ? new Date(process.env.VUE_APP_PREREGISTER_DATE)
    : new Date()
}
